<template>
  <div class="col px-0">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="text-subtitle-1 text-sm-h6 text-md-h5 font-weight-bold text-center">
      Relatório de Semeios MAPA
    </div>

    <v-card>  
      <v-card-title>
        <span>Filtros</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6" >
            <v-autocomplete
              v-model="cultureIds"
              label="Cultura(s)"
              :items="filtersList ? filtersList.accountContext.allCulturesForAccount : []"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="cultureIds = []"
              :loading="loadingFilters"
              multiple
              chips
              dense
              deletable-chips
              hint="Se nenhuma cultura for selecionada, todas serão exibidas"
              persistent-hint
            />
          </v-col>

          <v-col cols="12" md="6" >
            <v-autocomplete
              v-model="subCultureIds"
              label="Subcultura(s)"
              :items="subCulturesListComputed"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="subCultureIds = []"
              :loading="loadingFilters"
              multiple
              chips
              dense
              deletable-chips
              hint="Se nenhuma subcultura for selecionada, todas serão exibidas"
              persistent-hint
            />
          </v-col>

          <v-col cols="12" md="6" >
            <v-autocomplete
              v-model="varietyIds"
              label="Variedade(s)"
              :items="varietiesListComputed"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="varietyIds = []"
              :loading="loadingFilters"
              multiple
              chips
              dense
              deletable-chips
              hint="Se nenhuma variedade for selecionada, todas serão exibidas"
              persistent-hint
            />
          </v-col>

          <v-col cols="6" md="3">
            <v-autocomplete
              v-model="periodFilterModel"
              label="Período"
              :items="periodFilterOptions"
              item-value="key"
              item-text="name"
            />
          </v-col>
          <v-col cols="12" md="4" v-if="periodFilterModel == 'OTHER'">
            <DateRangeField
              :inputData.sync="periodFilterRangeModel"
              label="Período Customizado"
              :hasTodayDate="true"
            />
          </v-col>

          <v-col cols="6" md="2">
            <v-btn
              class="mt-3"
              @click="runFilter(false)">
              <v-icon left>mdi-magnify</v-icon>
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <div>
      <BasePrint
        printableElementId="seedlingPlantingMapaReportPrintTable"
        printButtonLabel="Imprimir"
        printTitle="Relatório de Vendas por Produto - Analítico"
        @start-printing="printing = loading = true"
        @stop-printing="printing = loading = false"
        class="mt-3"
      />
    </div>

    <div id="seedlingPlantingMapaReportPrintTable" v-if="seedlingPlantingMapaReport" class="mt-5">
      <v-row>
        <v-col cols="12">
          <BaseIndex
            ref="baseIndex"
            v-if="seedlingPlantingMapaReport"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="tableHeaders"
            :table-items="seedlingPlantingMapaReport.varieties"
            :maskFields="maskFields"
            :enableCustomFilters="false"
            :containTopToolbar="false"
            :itemsPerPage="-1"
            :disablePagination="true"
            :indexNested="true"
            :hasDefaultPageTitle="false"
          >
            <!-- <template slot="tableFooter">
              <tr class="d-none d-md-table-row">
                <td colspan="5" class="text-right title"><strong class="mx-3">Total:</strong></td>
                <td colspan="1" class="text-left title"><strong>{{ sale.productsTotalValue | formatCurrency }}</strong></td>
              </tr>

              < !-- for mobile only -- >
              <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Total</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ sale.productsTotalValue | formatCurrency }}</strong></div>
                </td>
              </tr>
            </template> -->

          </BaseIndex>
        </v-col>
      </v-row>

    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import BaseIndex from "@shared_components/base_index.vue";
import DateRangeField from "@shared_components/date_range_field.vue"
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      loading: false,
      loadingFilters: false,
      pageLoading: false,
      monthFilter: moment().format('YYYY-MM'),
      cultureIds: [],
      subCultureIds: [],
      varietyIds: [],
      seedlingPlantingMapaReport: null,
      startDate: null,
      endDate: null,
      filtersList: null,
      tableHeaders: [
        { text: "Variedade", align: "left", sortable: false, value: "varietyFullName"},
        { text: "Qtd. Plantada", align: "left", sortable: false, value: "plantingTotal"},
        { text: "Qtd. Perda", align: "left", sortable: false, value: "lossTotal"},
        { text: "Saldo", align: "left", sortable: false, value: "resultTotal"},
      ],
      maskFields: [
        { field: 'plantingTotal', mask: 'number' },
        { field: 'lossTotal', mask: 'number' },
        { field: 'resultTotal', mask: 'number' },
      ],
      periodFilterOptions: [
        { "key": "DAY", "name": "Hoje" },
        { "key": "WEEK", "name": "Esta Semana" },
        { "key": "MONTH", "name": "Este Mês" },
        { "key": "OTHER", "name": "Customizado" },
      ],
      periodFilterModel: "MONTH",
      periodFilterRangeModel: [moment().startOf('week').format('YYYY-MM-DD'), moment().endOf('week').format('YYYY-MM-DD')]
    };
  },
  props: {
  },
  components: {
    BaseIndex: BaseIndex,
    DateRangeField: DateRangeField,
    BasePrint: BasePrint,
  },
  created() {
    this.loadServerFilters();
  },
  mounted() {

  },
  computed: {
    subCulturesListComputed: function() {
      let list = [];
      if (this.filtersList) {
        list = this.filtersList.accountContext.allSubCulturesForAccount;
        if (this.cultureIds && this.cultureIds.length > 0) {
          list = list.filter(item => this.cultureIds.includes(item.cultureId));
        } 
      } 
      return list;
    },
    varietiesListComputed: function() {
      let list = [];
      if (this.filtersList) {
        list = this.filtersList.accountContext.allVarietiesForAccount;
        if (this.subCultureIds && this.subCultureIds.length > 0) {
          list = list.filter(item => this.subCultureIds.includes(item.subCultureId));
        } 
      } 
      return list;
    }
  },
  methods: {
    loadServerFilters: function() {
      this.loadingFilters = true;
      this.$apollo
        .query({
          query: LOAD_FILTERS_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.filtersList = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loadingFilters = false));
    },
    loadServerEntries: function(firstLoading=false) {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_SEEDLING_PLANTING_MAPA_QUERY,
          variables: {
            cultureIds: this.cultureIds,
            subCultureIds: this.subCultureIds,
            varietyIds: this.varietyIds,
            startDate: this.startDate,
            endDate: this.endDate
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.seedlingPlantingMapaReport = response.data.accountContext.seedlingPlantingMapaReport;
          console.log("this.seedlingPlantingMapaReport", this.seedlingPlantingMapaReport);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    runFilter: function(firstLoading=false) {
      if (this.periodFilterModel != "OTHER") {
        this.startDate = moment().startOf(this.periodFilterModel.toLocaleLowerCase()).format('YYYY-MM-DD');
        this.endDate   = moment().endOf(this.periodFilterModel.toLocaleLowerCase()).format('YYYY-MM-DD');

      } else {
        if (this.periodFilterRangeModel.length == 2) {
          this.startDate = this.periodFilterRangeModel[0];
          this.endDate   = this.periodFilterRangeModel[1];
        }
      }
      console.log(this.startDate, this.endDate);
      this.loadServerEntries(firstLoading);
      // this.startDate = moment(this.monthFilter, 'YYYY-MM').startOf('week').format('YYYY-MM-DD');
      // this.endDate   = moment(this.monthFilter, 'YYYY-MM').endOf('week').format('YYYY-MM-DD');
    },
    
  }
};

const LOAD_FILTERS_QUERY = gql `
  {
    accountContext {
      allCulturesForAccount {
        id
        name
      }
      allSubCulturesForAccount {
        id
        name
        cultureId
      }
      allVarietiesForAccount {
        id
        name
        subCultureId
      }
    }
  }
`;

const LOAD_SEEDLING_PLANTING_MAPA_QUERY = gql `
query ($startDate: ISO8601Date!, $endDate: ISO8601Date!, $cultureIds: [ID!]!, $subCultureIds: [ID!]!, $varietyIds: [ID!]!) {
  accountContext {
    seedlingPlantingMapaReport(cultureIds: $cultureIds, subCultureIds: $subCultureIds, varietyIds: $varietyIds, startDate: $startDate, endDate: $endDate) 
  }
}
`;

</script>

<style scoped>
</style>
